/* ========= ACTION TYPES ========= */
const SET_STEPS = "SET_STEPS";
const START_TOUR = "START_TOUR";
const STOP_TOUR = "STOP_TOUR";
const SET_STEP_INDEX = "SET_STEP_INDEX";
const SET_TOUR_LOCATION = "SET_TOUR_LOCATION";
const RESET_TOUR = "RESET_TOUR"

/* ========= ACTION CREATORS ========= */
export const setSteps = (steps) => ({
  type: SET_STEPS,
  payload: steps,
});

export const startTour = () => ({
  type: START_TOUR,
});

export const stopTour = () => ({
  type: STOP_TOUR,
});

export const setStepIndex = (index) => ({
  type: SET_STEP_INDEX,
  payload: index,
});

export const setTourLocation = (location) => ({
  type: SET_TOUR_LOCATION,
  payload: location,
});

export const resetTour = () => ({
  type: RESET_TOUR,
});

/* ========= INITIAL STATE ========= */
const initialState = {
  run: false,
  steps: [],
  stepIndex: 0,
  isTourOpen: false,
  tourLocation: 1,
};

/* ========= REDUCER ========= */
export default function tourReducer(state = initialState, action) {
  switch (action.type) {
    case SET_STEPS:
      return { ...state, steps: action.payload };

    case START_TOUR:
      return { ...state, run: true, isTourOpen: true };

    case STOP_TOUR:
      return { ...state, run: false, isTourOpen: false };

    case SET_STEP_INDEX:
      return { ...state, stepIndex: action.payload };

    case SET_TOUR_LOCATION:
      return { ...state, tourLocation: action.payload };
    case RESET_TOUR:
      // console.log("tour got reset")
      return {...initialState}

    default:
      return state;
  }
}
